import React from "react";

const SvgTagFriend = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      style={style}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.422 8.16237L11.4095 8.73737C10.1689 9.59362 8.50979 9.57487 7.29386 8.70925C7.19698 8.6405 7.10636 8.56862 7.01573 8.4905C6.04386 7.64362 5.59042 6.28737 5.85948 5.028C6.13448 3.75612 7.11886 2.69675 8.36573 2.33112C9.63167 1.95925 11.041 2.33112 11.9564 3.28112C12.8032 4.15612 13.1501 5.44987 12.8657 6.628C12.5032 6.65612 12.1657 6.803 11.9032 7.05612C11.6001 7.34362 11.4314 7.73425 11.422 8.14987V8.16237Z"
        fill="currentColor"
      />
      <path
        d="M11.4031 9.4749C11.4406 9.97803 11.65 10.4468 12.0031 10.8155L14.3531 13.2718C14.6406 13.5749 15.0312 13.7437 15.4469 13.753C15.4594 13.7562 15.4719 13.7562 15.4844 13.7562C15.8687 13.7562 16.2316 13.6187 16.5191 13.3593C16.5281 13.3499 16.5406 13.3405 16.5503 13.3312C16.5597 13.4187 16.5628 13.5093 16.5628 13.5968V15.7718C16.5628 16.1655 16.3159 16.5187 15.9472 16.653C11.7094 18.1968 7.04094 18.1937 2.80313 16.653C2.43438 16.5187 2.1875 16.1655 2.1875 15.7718V13.5968C2.1875 12.4187 2.77812 11.3374 3.77187 10.703C4.7875 10.053 5.9 9.5874 7.07812 9.32178C7.77187 9.76865 8.57156 9.99365 9.375 9.99365C10.075 9.99365 10.775 9.82178 11.4031 9.4749Z"
        fill="currentColor"
      />
      <path
        d="M17.5531 10.2127L15.2 7.75332C14.9159 7.45644 14.5312 7.28457 14.1156 7.27207C14.1125 7.27207 14.1094 7.27207 14.1062 7.27207L13.1125 7.2502L13.0562 7.24707H13.0094H13.0031C12.9966 7.24707 12.9872 7.24707 12.9812 7.24707C12.7403 7.24707 12.5094 7.34082 12.3344 7.50645C12.1531 7.68145 12.0534 7.9127 12.0469 8.15957V8.16582L12.0219 9.26269V9.26895C12.0128 9.68457 12.1656 10.0814 12.4531 10.3846L14.8062 12.8408C14.9781 13.0221 15.2125 13.1252 15.4628 13.1314C15.6972 13.1377 15.9503 13.0439 16.1316 12.8689L16.5534 12.4658L17.5225 11.5377C17.7037 11.3658 17.8069 11.1314 17.8131 10.8814C17.8187 10.6314 17.725 10.3939 17.5531 10.2127ZM13.7203 8.96082C13.6072 9.05832 13.4544 9.11207 13.2906 9.11207C12.9897 9.11207 12.6656 8.92301 12.6656 8.50738C12.6656 8.07144 13.0022 7.91676 13.2906 7.91676C13.5791 7.91676 13.9156 8.07144 13.9156 8.50738C13.9156 8.69176 13.8466 8.8527 13.7203 8.96082Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgTagFriend;
